import { BaseService } from '../../infra/base.service'
import type { AudienceRule } from './audience-rule'
import type { AudienceRulesRepository } from './audience-rules.repository'

export class AudienceRulesService extends BaseService<AudienceRule> {
    constructor(private rep: AudienceRulesRepository) {
        super(rep)
    }
}
